<template>
  <div>
    <div
      v-for="screen in screens"
      v-show="currentScreen === screen.number"
      :key="screen.number"
      class="Screen-container"
    >
      <dynamic-form-renderer
        v-if="!ui.isLoading"
        :screen="screen"
        read-only
      />
      <div
        :class="['ScreenActions', { 'disabled' : selectedQuestion.vuexId !== null}]"
      >
        <screen-selection-menu
          v-if="ui.showScreenNavigationMenu"
          v-click-outside="handleCloseScreenNavigationMenu"
        />

        <button
          class="Button Button-transparent ScreenNavigationArrow"
          @click.stop="toggleShowScreenMenu"
        >
          <span class="Icon Icon-list" />
        </button>

        <button
          :disabled="currentScreen === 1"
          class="Button Button-transparent ScreenNavigationArrow"
          @click="decrementCurrentFormScreen"
        >
          <span class="Icon Icon-arrow-up" />
        </button>
        <button
          :disabled="currentScreen === screens.length"
          class="Button Button-transparent ScreenNavigationArrow"
          @click="incrementCurrentFormScreen"
        >
          <span class="Icon Icon-arrow-down" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import DynamicFormRenderer from './dynamic-form-renderer';
import ScreenSelectionMenu from '../dynamic-form-builder/config-menus/screen-selection-menu';

export default {
  name: 'DynamicFormRendererReadOnly',
  components: {
    DynamicFormRenderer,
    ScreenSelectionMenu,
  },
  data() {
    return {
      ui: {
        showScreenNavigationMenu: false,
      },
    };
  },
  computed: {
    ...mapState('forms', {
      screens: (state) => state.screens,
      currentScreen: (state) => state.currentScreen,
      selectedQuestion: (state) => state.selectedQuestion,
      formQuestions: (state) => state.form.questions,
    }),
  },
  mounted() {
    if (this.currentScreen !== 1) {
      this.setCurrentScreenNumber(1);
    }
  },
  methods: {
    ...mapMutations('forms', ['setFormScreens', 'setCurrentScreenNumber',
      'incrementCurrentFormScreen', 'decrementCurrentFormScreen']),
    toggleShowScreenMenu() {
      this.ui.showScreenNavigationMenu = !this.ui.showScreenNavigationMenu;
    },
    handleCloseScreenNavigationMenu() {
      this.ui.showScreenNavigationMenu = false;
    },
  },
};
</script>

<style scoped lang="scss">

.Screen-container {
  .ScreenActions {
    position: relative;
    margin: 0 auto;
    max-width: 700px;
    height: 80px;

    &.disabled {
      button {
        cursor: not-allowed;
        pointer-events: none;
        color: #ccc;
        .Icon {
          color: #ccc;

          &:hover {
            cursor: not-allowed;
          }
        }
      }
    }
  }
  &.hidden {
    display: none;
  }

  .ScreenNavigationArrow {
    min-width: 45px;
    width: 45px;
    padding: 10px 0;
  }
}
</style>
